/**
 * @file CustomDatePicker.tsx
 * @module app/custom/DateRange/CustomDatePicker
 * @description Renders the CustomDatePicker control for selecting and formatting date or date-range filters in report and list workflows.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import "./dateRange.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
const CustomDatePicker = (props: any) => {
    return (
        <>
            <DatePicker
                className={props.className + " form-control form-control-custom borde-r8px bg-light min-h-60px fs-16 fw-bold text-dark"}
                selected={props.selected}
                onChange={props.onChange}
                startDate={props.startDate}
                endDate={props.endDate}
                dateFormat={props.dateFormat}
                selectsRange={props.selectsRange}
                showFullMonthYearPicker={props.showFullMonthYearPicker}
                maxDate={props.maxDate}
                isClearable={props.isClearable}
                disabled={props.disabled}
                minDate={props.minDate}
                filterDate={props.filterDate}
                placeholderText={props.selectsRange ? "Select Dates" : "Select Date"}
            />
        </>
    );
};
export default CustomDatePicker;
